import React, { useEffect, useState } from "react";
import { Router, Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { history } from "./history";
import AdminPage from "./pages/admin";
import LoginPage from "./pages/auth/login";
import { userOptions } from "./utils/storageUtils";
import { updateUserInfo } from "./redux/actions/auth";
import "./App.css";
import { refreshTokenApi } from "./api/auth";
import Spin from "./components/spin";

function App(props) {
  //初始化本地存储的用户信息到redux
  //等待更新用户信息
  const [waitForUserInfo, setWaitForUserInfo] = useState(props.waitForUserInfo);

  useEffect(() => {
    getUserInfoData();
  }, []);

  useEffect(() => {
    setWaitForUserInfo(props.waitForUserInfo);
  }, [props.waitForUserInfo]);

  const getUserInfoData = async () => {
    //检测用户是否已经登录过
    let userInfo = userOptions.getUserInfo();
    let result = null;
    if (userInfo && userInfo.token) {
      result = await refreshTokenApi();
      userOptions.saveUserInfo(result);
    }
    props.updateUserInfo(result);
  };

  return (
    <>
      {waitForUserInfo ? (
        <div>
          <Spin />
        </div>
      ) : (
        <Router history={history}>
          <Switch>
            <Redirect exact from="/" to="/login" />
            <Route path="/login" component={LoginPage} />
            <Route path="/" component={AdminPage} />
          </Switch>
        </Router>
      )}
    </>
  );
}

export default connect(
  (state) => ({ waitForUserInfo: state.auth.waitForUserInfo }),
  { updateUserInfo }
)(App);
